const mixin = {
  data() {
    return {
      tableHeight: 320,
      windowHeight: 0
    };
  },
  mounted() {
    // 3. 动态计算表格高度
    setTimeout(() => {
      this.handleSetTableHeight();
    }, 200);
    window.addEventListener('resize', this.handleSetTableHeight);
  },
  methods: {
    handleSetTableHeight() {
      this.windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      const headerHeight = document.querySelector('.header-wrapper-430')
        ? document.querySelector('.header-wrapper-430').clientHeight
        : 0;

      // 此处减去即为当前屏幕内除了表格高度以外其它内容的总高度，
      // this.tableHeight = windowHeight - headerHeight - 340
      // this.tableHeight =
      //   this.windowHeight - headerHeight - (this.windowHeight > 970 ? 240 : 270)

      this.tableHeight = this.windowHeight - headerHeight - 230;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleSetTableHeight);
  }
};

export default mixin;
